import { gql } from '@apollo/client';

// Separate query so older API deployments can keep their existing SMS flow.
export const physicianPushAvailability = gql`
  query physicianPushAvailability {
    physicianPushEnabled
  }
`;
